if (!customElements.get("design-your-own-picker")) {
  customElements.define(
    "design-your-own-picker",
    class DesignYourOwnPicker extends HTMLElement {
      constructor() {
        super();

        this.isDesktop = window.matchMedia("(min-width: 1024px)");

        this.addEventListener("change", this.updateSelections.bind(this));
        this.addEventListener("click", this.clearSelection.bind(this));
      }

      get productForm() {
        return document.forms[this.getAttribute("form")];
      }

      get accordionDetails() {
        return (this._accordionDetails =
          this._accordionDetails ||
          Array.from(this.querySelectorAll('details[is="accordion-details"]')));
      }

      connectedCallback() {
        this.updateSelections();
        window.addEventListener("load", this.updateSelections.bind(this));

        if (!this.isDesktop.matches) {
          this.accordionDetails.forEach((item, index) => {
            item.open = index === 0;
          });
          this.addEventListener("toggle", this.onToggle);
        }

        this.isDesktop.addEventListener("change", (event) => {
          if (event.matches) {
            this.removeEventListener("toggle", this.onToggle);
            this.accordionDetails.forEach((item) => {
              item.open = true;
            });
          } else {
            this.accordionDetails.forEach((item, index) => {
              item.open = index === 0;
            });
            this.addEventListener("toggle", this.onToggle);
          }
        });
      }

      onToggle(event) {
        const { current: target, open } = event.detail;
        this.accordionDetails.forEach((item) => {
          if (item !== target) {
            item.close();
          }
        });

        if (open) {
          let headerHeight = 0;
          if (
            !theme.config.mqlSmall &&
            document.querySelector("header.header")
          ) {
            headerHeight = Math.round(
              document.querySelector("header.header").clientHeight
            );
          }
          setTimeout(() => {
            window.scrollTo({
              top:
                target.getBoundingClientRect().top +
                window.scrollY -
                headerHeight,
              behavior: theme.config.motionReduced ? "auto" : "smooth",
            });
          }, 250);
        }
      }

      updateSelections(event) {
        if (!event || event.type === "load") {
          const selectedInputs = this.querySelectorAll(
            "input[name^='dyo_required_selection_']:checked, input[name^='dyo_optional_selection_']:checked"
          );
          selectedInputs.forEach((input) => {
            const selectedValue = this.querySelector(
              `label[for="${input.id}"]`
            ).title;
            const selectedLabel = input
              .closest("fieldset, details")
              .querySelector("[data-selected-label]");
            selectedLabel.textContent = selectedValue;
          });
        } else {
          const selectedValue =
            this.querySelector(`label[for="${event.target.id}"]`)?.title || "";
          const selectedLabel = event.target
            .closest("fieldset, details")
            .querySelector("[data-selected-label]");
          selectedLabel.textContent = selectedValue;
        }

        const requiredSelectionsInput = this.querySelector(
          "input[name='properties[_dyo_required_selections]']"
        );
        const requiredSelections = this.getSelections(
          this.querySelectorAll("input[name^='dyo_required_selection_']")
        );
        requiredSelectionsInput.value = requiredSelections;

        const optionalSelectionsInput = this.querySelector(
          "input[name='properties[_dyo_optional_selections]']"
        );
        const optionalSelections = this.getSelections(
          this.querySelectorAll("input[name^='dyo_optional_selection_']")
        );
        optionalSelectionsInput.value = optionalSelections;

        const detailsInput = this.querySelector(
          "input[name='properties[_dyo_details]']"
        );
        const detailsSelections = this.getSelections(
          this.querySelectorAll(
            "input[name^='dyo_required_selection_'], input[name^='dyo_optional_selection_']"
          ),
          false,
          "data-selection-details",
          "@@"
        );
        detailsInput.value = detailsSelections;

        const items = this.getOptionalItems(optionalSelections);
        (this.productForm ?? document).dispatchEvent(
          new CustomEvent("optionalProducts:change", {
            detail: {
              items,
            },
          })
        );

        (this.productForm ?? document).dispatchEvent(
          new CustomEvent("designYourOwn:change", {
            detail: {
              picker: this,
            },
          })
        );
      }

      getSelections(
        inputs,
        includeHidden = true,
        key = "value",
        separator = ","
      ) {
        // Group inputs by their name (radio button groups and single hidden inputs)
        const inputsByName = {};
        inputs.forEach((input) => {
          if (!inputsByName[input.name]) {
            inputsByName[input.name] = [];
          }
          inputsByName[input.name].push(input);
        });

        // Get all selected values and check for unselected required fields
        const selectedValues = {};

        Object.keys(inputsByName).forEach((fieldName) => {
          const inputs = inputsByName[fieldName];

          // Handle single hidden input (always has a value)
          if (inputs.length === 1 && inputs[0].type === "hidden") {
            if (!includeHidden) return;
            return (selectedValues[fieldName] = inputs[0].getAttribute(key));
          }

          // Handle radio button groups
          const selectedInput = inputs.find((input) => input.checked);
          selectedValues[fieldName] = selectedInput?.getAttribute(key);
        });

        const selections = Object.values(selectedValues)
          .filter(Boolean)
          .join(separator);
        return selections;
      }

      getOptionalItems(selections) {
        const bundles = Array.from(
          document.querySelectorAll(
            `[is=product-bundle-details][form="${this.getAttribute(
              "form"
            )}"] input[name="bundles"]:checked`
          )
        );
        return [
          ...bundles.map((bundle) => ({
            id: bundle.value,
            quantity: 1,
            price: bundle.getAttribute("data-price"),
          })),
          ...(selections
            ? selections.split(",").map((selection) => {
                const [id, price] = selection.split("|");
                return { id, quantity: 1, price };
              })
            : []),
        ];
      }

      clearSelection(event) {
        if (!event.target.closest("[data-clear-selection]")) return;

        const selectedInputs = event.target
          .closest("fieldset, details")
          .querySelectorAll(
            "input[name^='dyo_required_selection_']:checked, input[name^='dyo_optional_selection_']:checked"
          );
        selectedInputs.forEach((input) => {
          input.checked = false;
        });

        this.updateSelections(event);
      }
    }
  );
}
